//! вывод годов в фильтр от 2025 и далее по факту наступления след года
export const years = generateYears(2025, new Date().getFullYear());

function generateYears(fromYear: number, toYear: number) {
  const years = [];
  for (let year = fromYear; year <= toYear; year++) {
    years.push({ ID: year - fromYear + 1, Title: String(year) });
  }
  return years;
}

const toRomanNumeral = (num: number): string => {
  const romanNumerals = ['I', 'II', 'III', 'IV'];
  return romanNumerals[num - 1] || '';
};

const generateQuarters = (year: number) => {
  return [
    { ID: 1, Title: `I кв.${year}`, Value: 'Q1' },
    { ID: 2, Title: `II кв.${year}`, Value: 'Q2' },
    { ID: 3, Title: `III кв.${year}`, Value: 'Q3' },
    { ID: 4, Title: `IV кв.${year}`, Value: 'Q4' },
  ];
};

export const months = generateQuarters(new Date().getFullYear());

export const filterConfigPeriodGop = {
  year: {
    title: 'Год',
    hasSearch: false,
    options: years.map((item) => item.Title),
  },
  month: {
    title: 'Квартал',
    hasSearch: false,
    options: months.map((item) => item.Value),
  },
  groupGop: {
    title: 'Группа',
    hasSearch: true,
    searchPlaceholder: 'Поиск по группе',
    options: [],
  },
  formGop: {
    title: 'Форма GOP',
    hasSearch: true,
    searchPlaceholder: 'Поиск по форме GOP',
    options: [],
  },

  factoryGop: {
    title: 'Завод',
    hasSearch: true,
    searchPlaceholder: 'Поиск по заводу',
    options: [],
  },
};

const getCurrentDate = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  let currentQuarter;
  if (currentMonth <= 3) {
    currentQuarter = 1;
  } else if (currentMonth <= 6) {
    currentQuarter = 2;
  } else if (currentMonth <= 9) {
    currentQuarter = 3;
  } else {
    currentQuarter = 4;
  }

  const quarterName = `${toRomanNumeral(currentQuarter)} кв.${currentYear}`;

  return {
    month: {
      id: currentQuarter,
      name: quarterName,
    },
    year: {
      id: currentYear,
      name: currentYear.toString(),
    },
  };
};

const createInitialFilter = (gopList = []) => {
  const currentDate = getCurrentDate();
  let selectedGop = { id: null, description: '' };

  if (gopList && gopList.length > 0) {
    const sortedGops = [...gopList].sort((a, b) => {
      const descriptionA = (a.description || '').toLowerCase();
      const descriptionB = (b.description || '').toLowerCase();
      const descriptionComparison = descriptionA.localeCompare(descriptionB);

      if (descriptionComparison === 0) {
        const idA = a.id || a.ID;
        const idB = b.id || b.ID;
        return idA - idB;
      }

      return descriptionComparison;
    });

    selectedGop = {
      id: sortedGops[0].id || sortedGops[0].ID,
      description: sortedGops[0].description,
    };
  }

  return {
    year: {
      selected: [currentDate.year.name],
      selectedIds: [currentDate.year.id],
    },
    month: {
      selected: [currentDate.month.name],
      selectedIds: [currentDate.month.id],
    },
    formGop: {
      selected: selectedGop.description ? [selectedGop.description] : [],
      selectedIds: selectedGop.id ? [selectedGop.id] : [],
      search: '',
    },
    factoryGop: { selected: [], selectedIds: [], search: '' },
    groupGop: { selected: [], selectedIds: [], search: '' },
  };
};

export const getInitialFilterPeriodGop = createInitialFilter;

const currentDate = getCurrentDate();

export const initialFilterPeriodGop = {
  year: {
    selected: [currentDate.year.name],
    selectedIds: [currentDate.year.id],
  },
  month: {
    selected: [currentDate.month.name],
    selectedIds: [currentDate.month.id],
  },
  formGop: { selected: [], selectedIds: [], search: '' },
  factoryGop: { selected: [], selectedIds: [], search: '' },
  groupGop: { selected: [], selectedIds: [], search: '' },
};

export const filtersOpenPeriodGop = {
  year: false,
  month: false,
  formGop: false,
  factoryGop: false,
  groupGop: false,
};
